import { jsx as _jsx } from "react/jsx-runtime";
import CompleteIcon from "@mui/icons-material/CheckCircleOutline";
import IncompleteIcon from "@mui/icons-material/ErrorOutline";
export function SubconfigurationCompleteIndicatorIcon(props) {
    const { completed, color } = props;
    return completed ? (_jsx(CompleteIcon, { color: color })) : (_jsx(IncompleteIcon, { color: color }));
}
//# sourceMappingURL=SubconfigurationCompleteIndicator.js.map